<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 14:33:21
 * @LastEditTime: 2025-12-03 18:58:04
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    @close="onClose"
    :width="width"
    :modal="modal"
    :append-to-body="true"
    :show-close="false"
    v-on="$listeners"
    v-bind="$attrs"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="closeOnPressEscape"
    class="c-custom_dialog"
  >
    <template #title>
      <div class="c-custom_dialog__module_title">
        <div class="title_container">
          <el-tooltip
            placement="top"
            :content="title"
            v-if="title"
            :disabled="isShowTooltip"
          >
            <div
              class="title"
              @mouseover="
                onIsShowTooltipByMouseOver(`custom_dialog_title_${titleId}`)
              "
            >
              <span :id="`custom_dialog_title_${titleId}`">{{ title }}</span>
            </div>
          </el-tooltip>
          <slot v-else name="title"></slot>
          <div v-if="isShowClose" class="close_wrap">
            <i class="el-icon-close" @click="onClose"></i>
          </div>
        </div>
      </div>
    </template>

    <template #default>
      <div class="c-custom_dialog__module_content">
        <div>
          <slot :params="params"></slot>
        </div>
      </div>
    </template>

    <template #footer>
      <div v-if="defaultFooter" class="c-custom_dialog__module_default_footer">
        <div v-if="isShowClose" @click="onClose">取 消</div>
        <div @click="onConfirm">{{ defaultFooterText }}</div>
      </div>
      <div v-else class="c-custom_dialog__module_footer">
        <slot name="footer" :params="params"></slot>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { commonMixinByTooltip } from "@/components/aiChat/common/commonMixinByTooltip.js";
import tool from "@/components/aiChat/utils/tbox.js";
export default {
  name: "CustomDialog",
  props: {
    defaultFooter: {
      type: Boolean,
      default: true,
    },
    defaultFooterText: {
      type: String,
      default: "确 定",
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "50%",
    },
    modal: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },
    isShowClose: {
      // TODO 是否显示关闭相关按钮
      type: Boolean,
      default: true,
    },
    beforeClose: {
      type: [Function, String],
      default: "",
    },
  },
  mixins: [commonMixinByTooltip],
  data() {
    return {
      dialogVisible: false,
      titleId: tool.randomNumber(),
      params: {}, // 传递的参数
    };
  },
  methods: {
    onShow(params = {}) {
      this.dialogVisible = true;
      this.params = params;
    },
    onHide() {
      this.dialogVisible = false;
      this.params = {};
    },
    onConfirm() {
      this.$emit("on-dialog-confirm");
    },
    onClose() {
      if (this.beforeClose && this.dialogVisible) {
        this.beforeClose(() => {
          this.onHide();
          this.$emit("on-dialog-close");
        });
        return;
      }
      this.onHide();
      this.$emit("on-dialog-close");
    },
  },
};
</script>

<style lang="scss" scoped>
.c-custom_dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    box-shadow: none;
  }
  ::v-deep .el-dialog__header {
    padding: 7px 24px 7px;
  }
  ::v-deep .el-dialog__body {
    padding-right: 0;
    padding: 24px 24px 0;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #c9cdd4 !important;
    }

    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: #f7f8fa;
    }
  }
  ::v-deep .el-dialog__footer {
    padding: 0 24px 24px;
  }
  .c-custom_dialog__module_title {
    width: 100%;
    .title_container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      position: relative;
      // left: 8px;
      .title {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 26px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex-shrink: 0;
        max-width: 93%;
      }
      .close_wrap {
        width: 22px;
        height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          border-radius: 50%;
          background: rgb(242, 243, 245);
        }
        .el-icon-close {
          font-size: 18px;
          line-height: 21px;
          cursor: pointer;
          color: #86909c;
          position: relative;
          // top: -2px;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      // &::before {
      //   content: "";
      //   position: absolute;
      //   left: -11px;
      //   top: 50%;
      //   width: 3px;
      //   height: 14px;
      //   background: #165dff;
      //   border-radius: 0px;
      //   transform: translateY(-50%);
      // }
    }
  }
  .c-custom_dialog__module_content {
    ::v-deep .scroll_bar {
      > .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      > .is-horizontal {
        display: none;
      }
    }
  }

}
</style>